import { Link } from "gatsby"
import React, { useEffect, useState } from "react"

const RTOPopularState = () => {
  const [popularStates, setPopularStates] = useState([])
  const fetchPopularRtoStates = async () => {
    await fetch(`${window.location.origin}/api/v5/rto/popular_offices`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        setPopularStates(data)
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }
  useEffect(() => {
    fetchPopularRtoStates()
  }, [])
  return (
    <div className="clearfix statewise-rto">
      <div className="row">
        {popularStates &&
          popularStates
            .sort(function (a, b) {
              if (a.city.toLowerCase() < b.city.toLowerCase()) return -1
              if (a.city.toLowerCase() > b.city.toLowerCase()) return 1
              return 0
            })
            .map(state => {
              return (
                <div className="col-md-3">
                  <Link
                    to={`/rto-offices/${state.state_slug}/${
                      state.city_slug
                    }-${state.code.toLowerCase()}`}
                  >
                    {state.city}
                  </Link>
                </div>
              )
            })}
      </div>
    </div>
  )
}

export default RTOPopularState
